import React from 'react';
import { FunctionField } from 'react-admin';
import { Typography } from '@mui/material';
import { format, fromUnixTime } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';


const DATE_TIME_FORMAT = 'MMM d, yyyy, HH:mm';
const TIMEZONE = 'America/Toronto';

/**
 * Component for displaying timestamps in a formatted date/time
 * @param {string} source - The source field containing the timestamp (in seconds)
 * @param {string} label - The label to display for the field
 */
const DateTimeField = ({ source, label }) => (
  <FunctionField
    label={label}
    render={(record) => {
      const timestamp = record[source];
      if (!timestamp) return '-';

      const date = fromUnixTime(timestamp);
      const zonedDate = utcToZonedTime(date, TIMEZONE);
      return format(zonedDate, DATE_TIME_FORMAT);
    }}
  />
);

/**
 * Component for displaying timestamps in table cells
 */
export const TimestampCell = ({ timestamp }) => {
  if (!timestamp) return '-';

  const date = new Date(timestamp);
  const zonedDate = utcToZonedTime(date, TIMEZONE);

  return (
    <Typography variant="body2" color="text.secondary">
      {format(zonedDate, DATE_TIME_FORMAT)}
    </Typography>
  );
};

export default DateTimeField;
